import PostEmbed from './PostEmbed';

export default PostEmbed;
